<template>
  <div class="home">
  
    <Reproductor msg="Mi familia" audio2="../mp3/PrimariaB/03PB.mp3" cover="../img/2.jpg" name="Primaria B - Lección #3"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
